import { Component } from '@angular/core';

@Component({
  selector: 'ds-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: ['./feedback.component.scss']
})
/**
 * Component displaying the Feedback Statement
 */
export class FeedbackComponent {
}
